import React from "react";
import useModal from "../../../hooks/useModal";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import { FaUserPlus } from "react-icons/fa";
import ModalCreateUsuarioRS from "./ModalCreateUsuarioRS";

const CreateUsuarioRS = ({ refetch, usuarios }) => {
    const { open, close, isOpen } = useModal();

    return(
        <div>
            <Button text={<FaUserPlus size={22} />} bgColor="green" onClick={open} width="w-10"/>
            {isOpen &&
                <Modal title="Crear usuario" onClose={close}>
                    <ModalCreateUsuarioRS refetch={refetch} onClose={close} usuarios={usuarios} />
                </Modal>
            }
        </div>
    );
};

export default CreateUsuarioRS;